// AnimatedTitle.js
import React from "react";
import { motion } from "framer-motion";

export default function AnimatedTitle({ title, speedMs = 35 }) {
  // Split into words and the spaces between them, preserving spaces
  const tokens = title.split(/(\s+)/);

  // Variants for individual letters
  const letter = {
    hidden: { opacity: 0, y: 0 },
    visible: { opacity: 1, y: 0 },
  };

  // We’ll apply a global stagger manually so animation order is preserved
  let globalIdx = 0;
  const delayPerLetter = speedMs / 1000;

  return (
    <span /* not motion: we’re driving per-letter delays below */>
      {tokens.map((tok, ti) => {
        // Plain whitespace token → render as-is (normal spaces)
        if (/^\s+$/.test(tok)) {
          return <span key={`s${ti}`}>{tok}</span>;
        }

        // Word token → keep the whole word unbreakable, animate letters inside
        const letters = [...tok];
        return (
          <span
            key={`w${ti}`}
            style={{
              display: "inline-block",
              whiteSpace: "nowrap", // prevent breaking inside the word
            }}
          >
            {letters.map((ch, li) => {
              const myIdx = globalIdx++;
              return (
                <motion.span
                  key={`c${ti}-${li}`}
                  variants={letter}
                  initial="hidden"
                  animate="visible"
                  transition={{ delay: myIdx * delayPerLetter }}
                  style={{ display: "inline-block" }}
                >
                  {ch}
                </motion.span>
              );
            })}
          </span>
        );
      })}
    </span>
  );
}
